import Lottie from 'lottie-react';
import animationData from './commenda-loading-animation.json';

const Loading = ({
  size = 420,
  fit = 'contain',
}: {
  size?: number | 'auto';
  fit?: 'contain' | 'cover';
}) => {
  return (
    <div className="flex items-center justify-center w-full h-full">
      <Lottie
        animationData={animationData}
        loop
        autoplay
        rendererSettings={{
          preserveAspectRatio:
            fit === 'cover' ? 'xMidYMid slice' : 'xMidYMid meet',
        }}
        style={{ width: size, height: size }}
      />
    </div>
  );
};

export { Loading };
